/* ==========================================================================
   Tire Load Index Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-lic]');
  if (!root) return;

  /* Standard load index to pounds table. */
  var LOAD = {
    70:739,71:761,72:783,73:805,74:827,75:853,76:882,77:908,78:937,79:963,
    80:992,81:1019,82:1047,83:1074,84:1102,85:1135,86:1168,87:1201,88:1235,89:1279,
    90:1323,91:1356,92:1389,93:1433,94:1477,95:1521,96:1565,97:1609,98:1653,99:1709,
    100:1764,101:1819,102:1874,103:1929,104:1984,105:2039,106:2094,107:2149,108:2205,109:2271,
    110:2337,111:2403,112:2469,113:2535,114:2601,115:2679,116:2756,117:2833,118:2910,119:2998,
    120:3086,121:3197,122:3307,123:3417,124:3527,125:3638,126:3748
  };

  var SPEED = {
    L:{mph:75,kmh:120}, M:{mph:81,kmh:130}, N:{mph:87,kmh:140}, P:{mph:93,kmh:150},
    Q:{mph:99,kmh:160}, R:{mph:106,kmh:170}, S:{mph:112,kmh:180}, T:{mph:118,kmh:190},
    U:{mph:124,kmh:200}, H:{mph:130,kmh:210}, V:{mph:149,kmh:240}, W:{mph:168,kmh:270},
    Y:{mph:186,kmh:300}, Y2:{mph:186,kmh:300}
  };

  /* Tires are rated individually. Four of them carry the vehicle. */
  var WHEELS = 4;

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function compute(input) {
    var idx = Math.round(input.index);
    var perTire = LOAD[idx];
    if (!perTire) {
      return { ok: false, errors: ['Load index ' + idx + ' is not in the standard table. Check the number on the sidewall.'] };
    }
    var sp = SPEED[input.speed] || SPEED.H;
    var total = perTire * WHEELS;

    var status, warnings = [];
    if (isFinite(input.gvwr) && input.gvwr > 0) {
      var margin = ((total - input.gvwr) / input.gvwr) * 100;
      if (total < input.gvwr) {
        status = { key: 'critical', label: comma(total) + ' lb capacity',
                   note: 'Below the vehicle GVWR of ' + comma(input.gvwr) + ' lb. These tires are not rated to carry this vehicle.' };
      } else if (margin < 10) {
        status = { key: 'soon', label: comma(total) + ' lb capacity',
                   note: 'Only ' + num(margin, 0) + '% above GVWR. Thin margin once you add passengers and cargo.' };
      } else {
        status = { key: 'good', label: comma(total) + ' lb capacity',
                   note: num(margin, 0) + '% above the ' + comma(input.gvwr) + ' lb GVWR.' };
      }
    } else {
      status = { key: 'good', label: comma(total) + ' lb capacity',
                 note: comma(perTire) + ' lb per tire across four tires.' };
    }

    if (isFinite(input.required) && input.required > 0 && idx < input.required) {
      warnings.push('Below the manufacturer placard load index of ' + Math.round(input.required)
        + '. Fitting a lower rated tire than specified is not safe and in many places is not legal.');
      status.key = 'critical';
    }

    var rows = [
      { head: 'Load' },
      { label: 'Load index', value: String(idx) },
      { label: 'Per tire', value: comma(perTire) + ' lb' },
      { label: 'Four tires', value: comma(total) + ' lb' },
      { head: 'Speed' },
      { label: 'Rating', value: input.speed === 'Y2' ? '(Y)' : input.speed },
      { label: 'Maximum', value: sp.mph + ' mph  (' + sp.kmh + ' km/h)' },
      { head: 'Nearby load indexes' }
    ];
    for (var d = -3; d <= 3; d++) {
      var k = idx + d;
      if (LOAD[k]) rows.push({ label: String(k) + (d === 0 ? '  (yours)' : ''), value: comma(LOAD[k]) + ' lb' });
    }

    return {
      ok: true, errors: [], warnings: warnings, status: status,
      figures: [
        { label: 'Capacity per tire', value: comma(perTire) + ' lb',
          sub: comma(total) + ' lb across four tires.' },
        { label: 'Speed rating', value: (input.speed === 'Y2' ? '(Y)' : input.speed) + ' = ' + sp.mph + ' mph',
          sub: 'Sustained maximum at full load, not a target.' }
      ],
      rows: rows
    };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "index",
          "key": "i",
          "type": "number"
      },
      {
          "name": "speed",
          "key": "s",
          "type": "select"
      },
      {
          "name": "gvwr",
          "key": "g",
          "type": "number"
      },
      {
          "name": "required",
          "key": "r",
          "type": "number"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-lic__figure">'
        + '<div class="pc-lic__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-lic__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-lic__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-lic__row pc-lic__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-lic__row">'
        + '<span class="pc-lic__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-lic__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_LIC = { compute: compute };
})();
